import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { GapGameLaunchRequest } from "../models/requests/GapGameLaunchRequest";
import { GapGameLaunchResponse } from "../models/responses/GapGameLaunchResponse";

export const bharatSportsbookApi = {
  
    /* GAP game launch */
    gapGameLaunch: async (
        request: GapGameLaunchRequest
    ): Promise<UnifiedResponse<GapGameLaunchResponse>> => {
        const response = await apiClient.post<
            UnifiedResponse<GapGameLaunchResponse>
            >("/Gap/launchGap", request);

        return response.data;
    },
};
